import _ from "lodash";
import React, {Component} from 'react';
import { Field, reduxForm, FieldArray } from 'redux-form';
import {required, urlFormat, maxLength100, maxLength50} from "../../validation";
/*
@method: renderTextField
@desc: Render textarea input
*/
export function renderTextField(field){
    const { input, meta : { touched, error} } = field;
    const className = `form-group ${touched && error ? 'has-danger' : ''}`;
    const InputClassName = `form-control ${field.className ? field.className : ''}`;
    const placeholder = field.placeholder ? field.placeholder : '';
    return(
        <div className={className}>
            <label>{field.label }</label>
            <textarea maxLength={field.mxLength} className={InputClassName} {...input} placeholder={placeholder}></textarea>
            <div className="text-help">{(touched) ? error: ''}</div>
        </div>
    );
}
/*
@method: renderTextInputField
@desc: Render text input
*/
export function renderTextInputField(field){
    const { input, meta : { touched, error, active}, ...others } = field;
    const inputbox = `inputbox ${active ? 'active' : ''}`;
    const className = `form-group ${touched && error ? 'has-danger' : ''}`;
    const InputClassName = `form-control ${field.className ? field.className : ''}`;
    return(
        <div className={className}>
            <label>{field.label }{field.value}</label>
            <div className={inputbox}>
                <input maxLength={field.mxLength} {...others} type="text"  className={`form-control ${InputClassName}`} {...input} />
            </div>
            <div className="text-help">{(touched) ? error: ''}</div>
        </div>
    );
}

/*
@method: renderPasswordInputField
@desc: Render password input
*/
export function renderPasswordInputField(field){
    const { input, meta : { touched, error, active} } = field;
    const inputbox = `inputbox ${active ? 'active' : ''}`;
    const className = `form-group ${touched && error ? 'has-danger' : ''}`;
    const InputClassName = `form-control ${field.className ? field.className : ''}`;
    return(
        <div className={className}>
            <label>{field.label }</label>
            <div className={inputbox}>
                <input maxLength={32} type="password" className={InputClassName} {...input} />
            </div>
            <div className="text-help">{(touched) ? error: ''}</div>
        </div>
    );
}

/*
@method: renderEmailInputField
@desc: Render email input
*/
export function renderEmailInputField(field){
    const {input, isDisabled, meta : { touched, error, active}, ...others } = field;
    const disabled = isDisabled == true?true:false;
    const inputbox = `inputbox ${active ? 'active' : ''}`;
    const className = `form-group ${touched && error ? 'has-danger' : ''}`;
    const InputClassName = `form-control ${field.className ? field.className : ''}`;
    return(
        <div className={className}>
            <label>{field.label }</label>
            <div className={inputbox}>
                <input maxLength={50} {...others} disabled={disabled} type="text" className={InputClassName} {...input} />
            </div>
            <div className="text-help">{(touched) ? error: ''}</div>
        </div>
    );
}

/*
@method: renderSelectField
@desc: Render select input
*/
export function renderSelectField(field){
    const { meta : { touched, error, active} } = field;
    const inputbox = `inputbox ${active ? 'active' : ''}`;
    const className = `form-group ${touched && error ? 'has-danger' : ''}`;
    const InputClassName = `form-control ${field.className ? field.className : ''}`;
    let optionKey = 'id';
    let optionText = 'text';

    if(field.keys != undefined) {
        optionKey = field.keys[0];
        optionText = field.keys[1];
    }

    return(
        <div className={className}>
            <label>{field.label }</label>
            <div className={inputbox}>
                <select className={InputClassName} {...field.input}>
                    <option value=''>Select</option>
                    {
                        field.options.map((data) => {
                            return (
                                <option key={data[optionKey]} value={data[optionKey]}>{data[optionText]}</option>
                            )
                        })
                    }
                </select>
                <i className="icon-right-arrow"></i>
            </div>
            <div className="text-help">{(touched) ? error: ''}</div>
        </div>
    );
}

export function renderHiddenInputField(field){
    const { meta : { touched, error, active} } = field;
    return(
        <input type="hidden" value={field.val} />
    );
}


/*
@method: renderRadioInputField
@desc: Render radio input
*/

export function renderRadioInputField(field){
    const { input, meta : { touched, error, active}, ...others } = field;

    const inputbox = `inputbox ${active ? 'active' : ''}`;
    const className = `form-group ${touched && error ? 'has-danger' : ''}`;
    const InputClassName = `form-control ${field.className ? field.className : ''}`;
    return(
        <div className={className}>
                <label className="control control-checkbox">
                <span>{field.label }{field.value}</span>
                <input {...others} checked="true"className={`form-control ${InputClassName}`} {...input}
                />
                <div className="control_indicator"></div>
                </label>
            <div className="text-help">{(touched) ? error: ''}</div>
        </div>
    );
}

export class CheckboxGroup extends React.Component {

    checkboxGroup() {
        let {label, required, options, input, meta : { touched, error, active}} = this.props;
        const inputbox = `inputbox ${active ? 'active' : ''}`;
        const className = `form-group ${touched && error ? 'has-danger' : ''}`;
        const InputClassName = `form-control`;
        return _.map(options, (option, index) => {
            return (
                <li key={index}>

                    <div className={className}>

                        <div className={inputbox}>
                        <label className="control control-checkbox">
                            <span>{option}</span>
                            <input type="checkbox"
                                   name={`${input.name}[${index}]`}
                                   value={index}
                                   checked={input.value.indexOf(index) !== -1}
                                   onChange={(event) => {
                                       const newValue = [...input.value];
                                       if (event.target.checked) {
                                           newValue.push(index);
                                       } else {
                                           newValue.splice(newValue.indexOf(index), 1);
                                       }

                                       return input.onChange(newValue);
                                   }}/>
                            <div className="control_indicator"></div>
                            </label>
                        </div>
                        <div className="text-help">{(touched) ? error: ''}</div>
                    </div>
                </li>
            );
        });

    }

    render() {
        return (
            <ul className="small-block-grid-1 medium-block-grid-2">
                {this.checkboxGroup()}
            </ul>
        )
    }
}

export function renderStoryItems(field) {
    const {fields, meta: {error, touched}} = field;

    return (
        <div className={'row'}>
            {fields.map((nameWebsites, index) => (
                <div className="medium-12 columns" key={index}>
                    <div className="medium-5 columns">
                        <div className="form-group">
                            <label>Title of Story</label>
                            <Field
                                name={`${nameWebsites}.Title`}
                                component={renderTextInputField}
                                validate={[maxLength50]}
                                maxLength="50"
                            />
                        </div>
                    </div>
                    <div className="medium-5 columns">
                        <div className="form-group">
                            <label>Website (s)?</label>
                            <Field
                                name={`${nameWebsites}.Website`}
                                component={renderTextInputField}
                                validate={[urlFormat]}
                                maxLength="100"
                            />
                        </div>
                    </div>
                    {(fields.length > 1) && <div className="medium-2 columns">
                        <label></label>
                        <button type="button" className="btn-delete" onClick={(e) => {field.deleteItem(fields,index)}}>
                            Delete
                        </button>
                    </div>}
                </div>
            ))}

            <div className="medium-12 columns">
                <button type="button" onClick={() => {fields.push({});}} className="btn-add"><span>+</span> ADD MORE</button>
            </div>
            {error && touched && <li className="error">{error}</li>}
        </div>
    )
}



// WEBPACK FOOTER //
// ./components/Layout/FormInputs.js